const MEDIA_ITEMS = [
  {
    id: 1,
    title: '下拉式漫画阅读指南：从入门到沉迷',
    desc: '手把手教你如何享受下拉式漫画的极致阅读体验，掌握各种实用小技巧。',
    img: 'https://readdy.ai/api/search-image?query=A%20tutorial%20style%20illustration%20showing%20how%20to%20read%20vertical%20scroll%20comics%20on%20mobile%2C%20warm%20colors%2C%20modern%20flat%20design%2C%20clean%20UI%20elements%2C%20professional%20digital%20art%2C%20educational%20vibe&width=640&height=360&seq=media-01&orientation=landscape',
    duration: '阅读指南',
    icon: 'ri-guide-line',
  },
  {
    id: 2,
    title: '2026上半年最值得追的韩漫推荐',
    desc: '精选10部上半年最火爆的韩漫下拉式作品，部部都是高口碑佳作，追漫不踩雷。',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20colorful%20Korean%20manhwa%20book%20covers%20arranged%20in%20a%20grid%2C%20warm%20orange%20and%20cream%20background%2C%20modern%20flat%20design%2C%20professional%20presentation%2C%20clean%20layout&width=640&height=360&seq=media-02&orientation=landscape',
    duration: '精选合集',
    icon: 'ri-star-line',
  },
  {
    id: 3,
    title: '日漫vs韩漫：下拉式阅读体验大对比',
    desc: '从画风、叙事、分镜到阅读习惯，全面对比日漫与韩漫在下拉式阅读中的不同魅力。',
    img: 'https://readdy.ai/api/search-image?query=A%20side%20by%20side%20comparison%20of%20Japanese%20manga%20and%20Korean%20webtoon%20art%20styles%2C%20warm%20colors%2C%20modern%20flat%20design%2C%20clean%20split%20composition%2C%20professional%20illustration&width=640&height=360&seq=media-03&orientation=landscape',
    duration: '深度对比',
    icon: 'ri-contrast-2-line',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            精彩内容
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">漫画专题与攻略</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">精选漫画推荐指南与阅读攻略，发现更多好作品</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2 px-2.5 py-1.5 rounded-full bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-medium">
                  <i className={`${item.icon} text-sm`}></i>
                  <span>{item.duration}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-bold text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}